import React from 'react'
import PropTypes from 'prop-types'

const TwoColumnBlock = ({ input }) => (
  <div className="row" style={{paddingTop: 20}}>
    <div className="col-xs-12 col-lg-6" dangerouslySetInnerHTML={{__html: input.primary.right_column.html}} />
    <div className="col-xs-12 col-lg-6" dangerouslySetInnerHTML={{__html: input.primary.left_column.html}} />
  </div>
)

export default TwoColumnBlock

